import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { ForgotPasswordResponse } from '../models/forgot-password.model';

import { ApiService } from './api.service';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  private readonly API_URL = '/user';
  private apiService = inject(ApiService);
  private urlService = inject(UrlService);


  forgotPassword(email: string): Observable<ForgotPasswordResponse> {
    // For email URLs, only include UTM if it's in the current URL (not from preserved params)
    return this.apiService
      .post<ForgotPasswordResponse>(
        `${this.API_URL}/reset-password/${email}?url=${encodeURIComponent(this.urlService.buildUrl('/reset-password', true, true))}`,
        null
      )
      .pipe(
        tap(response => {
          if (response.status === 'success') {
            console.log('Email de recuperação enviado com sucesso');
          } else {
            console.error('Erro ao enviar email de recuperação:', response.status);
          }
        })
      );
  }
}


